import React, { useState } from "react";
import InterfaceComponent from "../Masters/InterfaceComponent";
import { ActionHandlerProvider } from "../../Components/ActionHandlerContext";
import { useRef } from "react";
import { FormInstance, Modal, Table } from "antd";
import { useNavigate } from "react-router-dom";
import { getTaskHistory } from "../../Helpers/APIEndpoints/Endpoints";
import { API } from "../../Axios/Axios";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import dayjs from "dayjs";
dayjs.extend(utc);
dayjs.extend(timezone);

const TaskDashboard = () => {
  const formRef = useRef<FormInstance>(null);
  const navigate = useNavigate();
  const [historyData, setHistoryData] = useState<any>([]);
  const [isHistoryIconClicked, setIsHistoryIconClicked] = useState(false);

  const formatToLocal = (utcDate: string) => {
    return dayjs.utc(utcDate).local().format("DD-MM-YYYY hh:mm A");
  };

  const Historycolumns = [
    {
      title: "Timestamp",
      dataIndex: "timestamp",
      key: "timestamp",
      render: (value: string) => formatToLocal(value),
    },
    {
      title: "Role",
      dataIndex: "role",
    },
    {
      title: "Username",
      dataIndex: "username",
    },
    {
      title: "Status",
      dataIndex: "status",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      render: (value: string) => value || "-",
    },
    {
      title: "TAT",
      dataIndex: "tat",
    },
  ];

  const handleHistoryClose = () => {
    setIsHistoryIconClicked(false);
    setHistoryData([]);
  };

  const interfaceActionHandler = {
    customJsonMethod: async (apiValues: any, fieldName: any) => {
      console.log("customJsonMethod called", 444);
      let value = {
        testMarks: 32358,
      };

      return value;
    },
    DynamicMasterRowEdit: async (apiValues: any, fieldName: any) => {
      console.log("DynamicMasterRowEdit called 1111", apiValues, fieldName);
    },
  };

  const interfaceFieldActionHandler = {
    hideShowTabsOnFieldChange: async (form: any) => {
      let formData: Record<string, any>;
      if ("getFieldsValue" in form) {
        formData = form.getFieldsValue();
      } else {
        formData = form;
      }
      console.log(formData);
    },
  };
  const rowActionHandler = {
    DynamicMasterRowView: async (...params: any[]) => {
      console.log(`${params[1]} action with parameters:`, params);
      console.log("rowActionHandler");
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay
      return true;
    },
    DynamicMasterRowEdit: async (...params: any[]) => {
      console.log(`${params[1]} action with parameters:`, params);
      console.log("rowActionHandler Edit 4422", params);
      // await new Promise((resolve) => setTimeout(resolve, 3000));
      navigate("/RequestDetailInterface", {
        state: {
          //id: params[1].interfaceId,
          // id : 8,
          actionType: "Edit",
          RId: params[1].RequestNumber,
          Mode: "Edit",
          TaskDetailId: params[1].Id,
          TabId: 6,
          IsTaskDashboard: true,
        },
      });
      return true;
    },
    History: async (...params: any[]) => {
      console.log("history");
      try {
        const obj = {
          TaskDetailId: params[1].Id,
        };
        const res = await API.post(getTaskHistory, obj);
        console.log("history res ==>", res);

        if (res?.data?.data?.length > 0) {
          setHistoryData(res?.data?.data);
        }

        setIsHistoryIconClicked(true);
      } catch (error) {
        console.error("History API Error:", error);
      }
    },
  };

  return (
    <>
      <ActionHandlerProvider
        //reportActionHandler={}
        rowActionHandler={rowActionHandler}
        interfaceActionHandler={interfaceActionHandler}
        interfaceFieldActionHandler={interfaceFieldActionHandler}
      >
        <InterfaceComponent
          InterfaceName={"Task Dashboard"}
          DashboardName={""}
          actionType={"DynamicFormActionCreate"}
          RId={null}
          Mode={"Create"}
          //handleCancel={handleCancel}
          ref={formRef}
        />
      </ActionHandlerProvider>
      <Modal
        title="Task History"
        open={isHistoryIconClicked}
        onOk={handleHistoryClose}
        onCancel={handleHistoryClose}
        footer={null}
        width={800}
        destroyOnClose
      >
        <Table
          columns={Historycolumns}
          dataSource={historyData || []}
          pagination={false}
          rowKey="id"
        />
      </Modal>
    </>
  );
};

export default TaskDashboard;
